<div class="bg-white py-6 flex flex-col justify-center sm:py-12">

    <!-- Basic Information -->
    <div class="mx-4">
        <div class="md:grid md:grid-cols-4 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Basic Information</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                        <!-- Title -->
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3 sm:col-span-2">
                                <label class="block text-sm font-medium text-gray-700">Title</label>
                                <div class="mt-1 flex rounded-md">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                            [innerHTML]="title | noSanitize"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Country -->
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3 sm:col-span-2">
                                <label class="block text-sm font-medium text-gray-700">Country</label>
                                <div class="mt-1 flex rounded-md">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                            [innerHTML]="country | noSanitize"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- City -->
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3 sm:col-span-2">
                                <label class="block text-sm font-medium text-gray-700">City</label>
                                <div class="mt-1 flex rounded-md">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                            [innerHTML]="city | noSanitize"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- City Population -->
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3 sm:col-span-2">
                                <label class="block text-sm font-medium text-gray-700">City Population</label>
                                <div class="mt-1 flex rounded-md">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                            [innerHTML]="cityPopulation | noSanitize"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Year of Implementation -->
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3 sm:col-span-2">
                                <label class="block text-sm font-medium text-gray-700">Year of Implementation</label>
                                <div class="mt-1 flex rounded-md">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                            [innerHTML]="durationFrom | noSanitize"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Overview -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
    <div class="mx-4">
        <div class="md:grid md:grid-cols-4 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Overview</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                        <!-- Overview Content -->
                        <div class="mt-1 flex rounded-md">
                            <div class="ql-container ql-snow" style="border-width: 0;">
                                <div class="ql-editor sm:text-sm border border-gray-300"
                                    [innerHTML]="overview | noSanitize"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Concrete Actions -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
    <div class="mx-4">
        <div class="md:grid md:grid-cols-4 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Concrete Actions</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white space-y-6 sm:p-6" *ngFor="let implementation of implementations">
                        <!-- Actions Content -->
                        <div>
                            <label class="block text-sm font-medium text-gray-700">Actions</label>
                            <div class="mt-1 flex rounded-md">
                                <div class="ql-container ql-snow" style="border-width: 0;">
                                    <div class="ql-editor sm:text-sm border border-gray-300"
                                        [innerHTML]="implementation.content | noSanitize"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Lessons Learned -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
    <div class="mx-4">
        <div class="md:grid md:grid-cols-4 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Lessons Learned</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white space-y-6 sm:p-6" *ngFor="let multi of multiObjective">
                        <!-- Lessons Content -->
                        <div>
                            <label class="block text-sm font-medium text-gray-700">Lessons</label>
                            <div class="mt-1 flex rounded-md">
                                <div class="ql-container ql-snow" style="border-width: 0;">
                                    <div class="ql-editor sm:text-sm border border-gray-300"
                                        [innerHTML]="multi.content | noSanitize"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Links -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>
    <div class="mx-4">
        <div class="md:grid md:grid-cols-4 md:gap-6">
            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Links</h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                        <!-- References -->
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3 sm:col-span-2">
                                <div class="mt-2 rounded-md" *ngFor="let reference of references">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <a [href]="reference" target="_blank" rel="noopener noreferrer">
                                            {{ reference }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>